module.exports = __webpack_public_path__ + "vue_assets/img/ic_downloads.bafd7e2f.svg";